// ============================================
// CONTRATOS.JS — Gestión de contratos de mantenimiento
// ============================================

import React, { useState } from 'react';
import { BarraPestanas, BarraBusqueda, FiltrosRapidos, ContadorResultados } from './utils/filtros';
import { BadgeFolio } from './utils/folios';
import { OPC_DINERO } from './utils/dinero';

const PP = "'Poppins', sans-serif";
const colores = { principal: '#5c9adb', oscuro: '#2f5f9e', gris: '#4e5357', grisClaro: '#5e666e', verde: '#5cd4b0', rojo: '#e05c5c', fondo: '#f3f4f4' };

const contratosData = [
  { id: 1, folio: 'MNT-2024-001', cliente: 'Bodegas Alianza', sucursales: 8, equiposPorSuc: 3, totalEquipos: 24, precioEquipo: 450, totalMensual: 10800, fechaInicio: '2024-10-01', duracion: 36, mesActual: 18, estatus: 'Activo', proximaFactura: '2026-04-01' },
  { id: 2, folio: 'MNT-2025-001', cliente: 'Farma Plus', sucursales: 2, equiposPorSuc: 4, totalEquipos: 8, precioEquipo: 500, totalMensual: 4000, fechaInicio: '2025-10-01', duracion: 24, mesActual: 6, estatus: 'Activo', proximaFactura: '2026-04-01' },
  { id: 3, folio: 'MNT-2025-002', cliente: 'Hotel Gran Plaza', sucursales: 1, equiposPorSuc: 12, totalEquipos: 12, precioEquipo: 400, totalMensual: 4800, fechaInicio: '2025-02-01', duracion: 12, mesActual: 14, estatus: 'Por renovar', proximaFactura: '2026-04-01' },
];

const estCfg = { Activo: { bg: '#e8faf5', color: '#1D9E75' }, 'Por renovar': { bg: '#fffbe6', color: '#7a6e00' }, Vencido: { bg: '#fde8e8', color: '#e05c5c' } };

function Contratos({ pestanaInicial = 'activos' }) {
  const [tab, setTab] = useState(pestanaInicial);
  const [busqueda, setBusqueda] = useState('');
  const [detalleId, setDetalleId] = useState(null);
  const [tabDetalle, setTabDetalle] = useState('resumen');

  const [width] = useState(window.innerWidth);
  const esCelular = width < 768;

  const filtrados = contratosData.filter(c => {
    if (busqueda) { const q = busqueda.toLowerCase(); if (!c.folio.toLowerCase().includes(q) && !c.cliente.toLowerCase().includes(q)) return false; }
    if (tab === 'renovar') return c.estatus === 'Por renovar';
    return true;
  });

  if (detalleId) {
    const c = contratosData.find(x => x.id === detalleId);
    if (!c) { setDetalleId(null); return null; }
    const ec = estCfg[c.estatus] || estCfg.Activo;
    const pctDuracion = Math.round((c.mesActual / c.duracion) * 100);
    return (
      <div style={{ fontFamily: PP }}>
        <button onClick={() => setDetalleId(null)} style={{ background: colores.fondo, border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px 14px', fontSize: '13px', cursor: 'pointer', color: colores.gris, marginBottom: '16px' }}>{'←'} Volver</button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <BadgeFolio folio={c.folio} />
          <div style={{ fontSize: '18px', fontWeight: '700', color: colores.gris }}>{c.cliente}</div>
          <span style={{ padding: '3px 12px', borderRadius: '8px', background: ec.bg, color: ec.color, fontSize: '11px', fontWeight: '600' }}>{c.estatus}</span>
        </div>

        <BarraPestanas tabs={[{ key: 'resumen', label: 'Resumen' }, { key: 'sucursales', label: 'Sucursales' }, { key: 'facturacion', label: 'Facturación' }, { key: 'bitacora', label: 'Bitácora' }]} activo={tabDetalle} onChange={setTabDetalle} />

        {tabDetalle === 'resumen' && (
          <div style={{ display: 'grid', gridTemplateColumns: esCelular ? '1fr' : '1fr 1fr', gap: '14px' }}>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '20px' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', color: colores.grisClaro, marginBottom: '12px', textTransform: 'uppercase' }}>Progreso del contrato</div>
              <div style={{ fontSize: '28px', fontWeight: '800', color: colores.principal, marginBottom: '4px' }}>Mes {c.mesActual} de {c.duracion}</div>
              <div style={{ height: '10px', background: '#e8e8e8', borderRadius: '5px', overflow: 'hidden', marginBottom: '8px' }}>
                <div style={{ height: '100%', width: `${pctDuracion}%`, background: pctDuracion > 80 ? '#1D9E75' : colores.principal, borderRadius: '5px', transition: 'width 0.8s ease' }} />
              </div>
              <div style={{ fontSize: '11px', color: colores.grisClaro }}>{pctDuracion}% completado · Inicio: {c.fechaInicio}</div>
            </div>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '20px' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', color: colores.grisClaro, marginBottom: '12px', textTransform: 'uppercase' }}>Montos</div>
              {[{ l: 'Precio por equipo', v: '$' + c.precioEquipo.toLocaleString('es-MX', OPC_DINERO) + '/mes' }, { l: 'Total equipos', v: c.totalEquipos }, { l: 'Sucursales', v: c.sucursales }, { l: 'Total mensual', v: '$' + c.totalMensual.toLocaleString('es-MX', OPC_DINERO) }].map((d, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}>
                  <span style={{ color: colores.grisClaro }}>{d.l}</span>
                  <span style={{ color: colores.gris, fontWeight: '600' }}>{d.v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {tabDetalle === 'sucursales' && (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '20px' }}>
            <div style={{ fontSize: '13px', color: colores.grisClaro, textAlign: 'center', padding: '20px' }}>{c.sucursales} sucursales con {c.equiposPorSuc} equipos cada una — {c.totalEquipos} equipos totales</div>
          </div>
        )}

        {tabDetalle === 'facturacion' && (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '20px' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', color: colores.gris, marginBottom: '8px' }}>Próxima factura: {c.proximaFactura}</div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: colores.principal }}>${c.totalMensual.toLocaleString('es-MX', OPC_DINERO)} MXN</div>
            <button style={{ marginTop: '14px', padding: '10px 16px', background: colores.oscuro, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', fontFamily: PP }}>Generar factura mensual</button>
          </div>
        )}

        {tabDetalle === 'bitacora' && (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '20px', textAlign: 'center', color: colores.grisClaro, fontSize: '13px' }}>Historial de servicios realizados bajo este contrato</div>
        )}
      </div>
    );
  }

  return (
    <div style={{ fontFamily: PP }}>
      <BarraPestanas tabs={[{ key: 'activos', label: 'Contratos activos' }, { key: 'renovar', label: 'Por renovar' }]} activo={tab} onChange={setTab} />
      <BarraBusqueda value={busqueda} onChange={setBusqueda} placeholder="Buscar por folio o cliente..." />
      <ContadorResultados total={contratosData.length} filtrados={filtrados.length} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
        {filtrados.map(c => {
          const ec = estCfg[c.estatus] || estCfg.Activo;
          const pct = Math.round((c.mesActual / c.duracion) * 100);
          return (
            <div key={c.id} onClick={() => { setDetalleId(c.id); setTabDetalle('resumen'); }} style={{ background: '#fff', borderRadius: '14px', padding: '16px', cursor: 'pointer', borderLeft: `4px solid ${ec.color}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', flexWrap: 'wrap' }}>
                <BadgeFolio folio={c.folio} />
                <span style={{ padding: '2px 10px', borderRadius: '8px', background: ec.bg, color: ec.color, fontSize: '10px', fontWeight: '600' }}>{c.estatus}</span>
                <span style={{ fontSize: '11px', color: colores.grisClaro, marginLeft: 'auto' }}>Mes {c.mesActual}/{c.duracion}</span>
              </div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris, marginBottom: '4px' }}>{c.cliente}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: colores.grisClaro, marginBottom: '6px' }}>
                <span>{c.sucursales} sucursales · {c.totalEquipos} equipos</span>
                <span style={{ fontWeight: '600', color: colores.principal }}>${c.totalMensual.toLocaleString('es-MX', OPC_DINERO)}/mes</span>
              </div>
              <div style={{ height: '4px', background: '#e8e8e8', borderRadius: '2px' }}><div style={{ height: '100%', width: `${pct}%`, background: ec.color, borderRadius: '2px' }} /></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Contratos;
